<div
  *ngIf="tooltip"
  class="tooltip">
  <div
    class="tooltip__header"
    data-cy="spy-line-chart-tooltip.title">
    {{ tooltip.title }}
  </div>
  <div
    *ngFor="let value of tooltip.values"
    [ngStyle]="{'color': value.color}"
    class="tooltip__values-wrapper"
    data-cy="spy-line-chart-tooltip.value-row">
    <span
      class="tooltip__values-label"
      data-cy="spy-line-chart-tooltip.label">
      {{ (label ? label + ' ' : '') + value.label}}
    </span>
    <span
      class="tooltip__values-value"
      data-cy="spy-line-chart-tooltip.value">
      {{ value.value }}
    </span>
  </div>
</div>
